import { useEffect, useRef, useState } from "react";
import * as Sentry from "@sentry/browser";
import LoaderImg from "@assets/images/loader.gif";
import { getData, handlePatch, refreshOnboardingData } from "./utils";

const OnBoardingDropdown = ({ onboardingDropdown, setOnboardingDropdown, setItemClicked, itemClicked, handleSetCurrOnboarding, updatingOnboardingData, type }) => {
  const obref = useRef();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!obref.current?.contains(event.target)) setOnboardingDropdown(false);
    };
    if (onboardingDropdown) {
      document.addEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [onboardingDropdown]);

  useEffect(() => {
    const fetchData = async () => {
      if (onboardingDropdown) {
        const onboardingData = await getData("onboarding_details");
        if (onboardingData && Object.keys(onboardingData)?.length > 0) {
          setData(onboardingData);
          setLoading(false);
        } else {
          setLoading(true);
          try {
            const data = await refreshOnboardingData();
            if (data && data.onboarding_details) {
              setData(data.onboarding_details);
              updatingOnboardingData(data);
            } else {
              setData({});
            }
          } catch (err) {
            Sentry.captureException(err);
            setData({});
          } finally {
            setLoading(false);
          }
        }
      }
    };
    fetchData();
  }, [onboardingDropdown]);

  useEffect(() => {
    const handleStorageChange = async (e) => {
      if (e.key === "onboarding" && onboardingDropdown) {
        const newData = await getData("onboarding_details");
        if (newData && Object.keys(newData).length > 0) {
          setData(newData);
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [onboardingDropdown]);

  const handleItemClick = (e, item, key) => {
    setItemClicked(!itemClicked);
    handleSetCurrOnboarding(key, "dropdown");
    //this is to set 'isVieweed true' in backedn when click from
    if (!data[key].isViewed && !type) {
      handlePatch("onboarding", key);
    }
    const data_ = JSON.parse(localStorage.getItem("onboarding"));
    const onboardingData = data_.onboarding_details;
    const updatedOnboardingData = {
      ...onboardingData,
      [key]: {
        ...onboardingData[key],
        isViewed: true,
      },
    };
    const newData = {
      ...data_,
      onboarding_details: updatedOnboardingData,
    };
    localStorage.setItem("onboarding", JSON.stringify(newData));
    setData(updatedOnboardingData);
    updatingOnboardingData(newData);
    e.stopPropagation();
  };

  return (
    <div ref={obref} className="tw-absolute tw-top-10 tw-right-0 tw-flex tw-flex-col tw-bg-white tw-p-2 tw-border tw-rounded-lg tw-shadow-sideDrawer tw-min-w-[340px] tw-min-h-[300px] tw-items-center tw-justify-center">
      {loading ? (
        <div className="">
          <img src={LoaderImg} alt="description of gif" />
        </div>
      ) : (
        Object.entries(data).map(([key, item], index) => (
          <div key={key}>
            <div className="tw-flex tw-flex-col tw-gap-1 tw-p-2 tw-cursor-pointer hover:tw-bg-gray-50 tw-rounded" onClick={(e) => handleItemClick(e, item, key)}>
              <div className="tw-flex tw-justify-between tw-items-center">
                <span className="tw-text-sm tw-font-medium">{item.title}</span>
                <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#7143f1">
                  <path d="m384-312 264-168-264-168v336Zm96.28 216Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Z" />
                </svg>
              </div>
              <span className="tw-text-xs tw-font-normal tw-text-gray-600">{item.brief}</span>
            </div>
            {index !== Object.entries(data).length - 1 && <div className="tw-border-t tw-border-gray-200 tw-my-1"></div>}
          </div>
        ))
      )}
    </div>
  );
};

export default OnBoardingDropdown;
